import API from '@aws-amplify/api';
import Constant from '@/common/constant/Constant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import { getUserNotificationList } from '../graphql/queries';
import { updateNotification } from '@/graphql/mutations';


/**
 * getAllNotificationOfUserEachPage
 * @param {*} APIClient 
 * @param {*} params 
 * @returns {Object} { notificationList, page, totalPage }
 */
export const getUserNotificationListByParams = async (APIClient, params) => {
    const res = await API.graphql({
        query: getUserNotificationList,
        variables: {
            params: {
                ...params
            },
        },
    });

    let notificationListData = !Utils.isEmptyObject(res?.data?.getUserNotificationList)
        ? res?.data?.getUserNotificationList
        : { notificationList: [], page: 1, totalPage: 1 };
    return notificationListData;
}

export const getUnReadNotificationListOfUser = async (APIClient, projectList, type) => {
    try {
        let corporationId = localStorageUtil.getAffiliationOrganization();
        let userId = localStorageUtil.getUserDetailId();

        const res = await API.graphql({
            query: getUserNotificationList,
            variables: {
                params: {
                    userId: userId,
                    corporationId: corporationId,
                    projectList: !Utils.isEmptyArray(projectList) ? JSON.stringify(projectList) : '',
                    type: type ? type : Constant.TYPE_GET_NOTIFICATION_LIST.ALL,
                },
            },
        });

        let notificationList = !Utils.isEmptyArray(res?.data?.getUserNotificationList?.notificationList)
            ? res?.data?.getUserNotificationList?.notificationList
            : [];
        return notificationList;
    } catch (err) {
        console.log('getUnReadNotificationListOfUser err', err);
        return [];
    }
};

export const updateNotificationDetail = async (APIClient, notificationId, notificationData) => {
    try {
        let input = {
            id: notificationId,
            ...notificationData,
        };
        let res = await API.graphql({ query: updateNotification, variables: { input: input } });
        return res.data?.updateNotification;
    } catch (err) {
        console.log(err);
        return null;
    }
}
